export const actionColumnProps = (props) => ({
  width: 36,
  minWidth: 0,
  type: 'action',
  align: 'center',
  disableFilters: true,
  canResize: false,
  ...props,
});
